<span class="project_label {{project.certification.toLowerCase()}}">
	<span [innerHTML]="global.getCertLabel(project)">
	</span>
</span>